import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TimeSlotDateTime } from '@enx/shared/util/models';

@Component({
  selector: 'enx-shared-ui-time-slot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-ui-time-slot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiTimeSlotComponent {
  timeSlot = input.required<TimeSlotDateTime>();
  isSelected = input(false);

  content = computed(() => `${this.timeSlot().from.toFormat('H:mm')} - ${this.timeSlot().to.toFormat('H:mm')}`);
}
